import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

function Floor3K6() {
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const imageRef = useRef(null);
  const customFloorUrl = '3'

    // Initial hover animation with delay
  useEffect(() => {
    let stopTimeout;
    const delay = setTimeout(() => {
      setIsHovered(true);
      stopTimeout = setTimeout(() => {
        setIsHovered(false);
      }, 300);
    }, 5900);
    return () => {
      clearTimeout(delay);
      if (stopTimeout) clearTimeout(stopTimeout);
    };
  }, []);

  // Detect if screen size is small or medium (below 1024px)
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024); // lg breakpoint is 1024px
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // Handle clicking outside the image to remove hover effect on mobile
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (imageRef.current && !imageRef.current.contains(event.target)) {
        setIsHovered(false);
        setIsClicked(false);
      }
    };

    if (isMobile && isClicked) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => document.removeEventListener("click", handleClickOutside);
  }, [isMobile, isClicked]);

  const handleClick = () => {
    if (isMobile) {
      if (!isClicked) {
        setIsHovered(true); // First click acts like hover
        setIsClicked(true);
      } else {
        navigate("/third-floor", { state: { customFloorUrl } }); // Second click navigates
      }
    } else {
      navigate("/third-floor", { state: { customFloorUrl } }); // On laptop, just navigate on click
    }
  };

  return (
    <>
      {/* Green Image (Hidden by Default, Appears on Hover or Click for Mobile) */}
      <img
        ref={imageRef}
        className={`absolute w-[19.3vw] right-[20.75vw] top-[33.8vw] cursor-pointer transition-opacity duration-300 ${isHovered ? "opacity-100" : "opacity-0"
          }`}
        src="/images/click/clickable-images/Floors/Floor3-K6-Green.png"
        alt=""
        onMouseEnter={() => !isMobile && setIsHovered(true)} // Hover effect for laptop
        onMouseLeave={() => !isMobile && setIsHovered(false)} // Only reset hover on laptop
        onClick={handleClick} // Click-to-hover for mobile
      />

      {/* Tooltip on Hover or Click (for Mobile) */}
      {isHovered && (
        <span className="absolute right-[14vw] top-[33vw] bg-[#192929] montserrat font-medium text-white text-xs lg:text-base px-2 lg:px-4 py-2 lg:py-3 shadow-md">
          Kati 3
        </span>
      )}
    </>
  );
}

export default Floor3K6;
